<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-tabs v-model="currentTab" type="card">
      <el-tab-pane label="通用模板" name="通用模板">
        <CommonMessage :studentList="dataListSelections"></CommonMessage>
      </el-tab-pane>
      <el-tab-pane label="放假通知" name="放假通知">
        <HolidayMessage :studentList="dataListSelections"></HolidayMessage>
      </el-tab-pane>
    </el-tabs>
    <div style="margin-top: 20px">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="生日月份：">
          <el-select
            v-model="dataForm.birthMonth"
            placeholder="请选择"
            style="width: 100%"
            size="mini"
          >
            <el-option label="全部月份" value=""> </el-option>
            <el-option
              v-for="(item, index) in monthList"
              :key="item"
              :label="item"
              :value="index + 1"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索：">
          <el-input
            v-model="dataForm.keyname"
            placeholder="请输入名称进行搜索"
            suffix-icon="el-icon-search"
            clearable
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="录入时间：">
          <el-date-picker
            style="width: 100%"
            v-model="queryDatePicker"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getDataList()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div class="table-head">
        <div class="label-wrapper">
          已选数量（{{ dataListSelections.length }}条）
        </div>
      </div>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        row-key="id"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column label="学员姓名" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="性别" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 1">男</span>
            <span v-else-if="scope.row.sex === 0">女</span>
          </template>
        </el-table-column>
        <el-table-column
          label="课程数"
          header-align="center"
          align="center"
          prop="courseCount"
        ></el-table-column>
        <el-table-column
          label="账户余额"
          header-align="center"
          align="center"
          prop="coin"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="录入时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="联系电话"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import CommonMessage from "./common-message.vue";
import HolidayMessage from "./holiday-message.vue";

export default {
  mixins: [mixinViewModule],
  components: { CommonMessage, HolidayMessage },
  data() {
    return {
      currentTab: "通用模板",
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: "/yxs/student/page",
        getDataListIsPage: true,
        exportURL: "/yxs/student/export",
        deleteURL: "/yxs/student",
        deleteIsBatch: true,
      },
      dataForm: {
        beginDate: "",
        endDate: "",
        keyname: "",
        birthMonth: "",
        campusId: "",
      },
    };
  },
  watch: {},
  computed: {},
  activated() {
    this.getDataList();
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
